import * as ReserveActions from './actions';

const initialState = {
  type: null,
  added: false,
  synced: false,
  fetched: false,
  processing: -1,
  confirmedQueue: [],
  txCount: 0,
  pathnameAtSynced: null
}

const actionEnum = [
];

const reserveReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReserveActions.RESERVE_INITIALIZING: {
      return {
        ...state,
        synced: true,
        fetched: false,
        confirmedQueue: state.confirmedQueue
      }
    }
    case ReserveActions.RESERVE_INITIALIZED: {
      return {
        ...state,
        fetched: true
      }
    }
    case ReserveActions.RESERVE_ADDED: {
      return {
        ...state,
        added: true
      }
    }
    case ReserveActions.RESERVE_CHANGE_QUEUE: {
      return {
        ...state,
        synced: true,
        added: false,
        processing: 1,
        confirmedQueue: action.confirmedQueue
      }
    }
    case ReserveActions.RESERVE_COMPLETED: {
      return {
        ...state,
        processing: 0,
        confirmedQueue: [],
        txCount: 0
      }
    }
    case ReserveActions.RESERVE_CHANGE_NONCE: {
      return {
        ...state,
        txCount: action.txCount
      }
    }
    case ReserveActions.TX_BROADCAST_RECEIVED: {
      return {
        ...state,
        type: ReserveActions.TX_BROADCASTED,
        processing: 1
      }
    }
    case ReserveActions.TX_ERROR: {
      return {
        ...state,
        type: action.type,
        processing: 0,
      }
    }
    case ReserveActions.CONTRACT_SYNC_IND: {
      return {
        ...state,
        type: ReserveActions.CONTRACT_SYNC_IND
      }
    }
    case ReserveActions.RESERVE_BLOCK_RECEIVED: {
      return {
        ...state,
        type: ReserveActions.BLOCK_RECEIVED
      }
    }
    case ReserveActions.CONTRACT_SYNC_RECEIVED: {
      return {
        ...state,
        type: ReserveActions.CONTRACT_SYNCED,
        fetched: false,
        synced: true,
        pathnameAtSynced: action.pathnameAtSynced
      }
    }
    case ReserveActions.RESERVE_AFTER_SYNC: {
      return {
        ...state,
        pathnameAtSynced: null
      }
    }
    case ReserveActions.TX_SUCCESSFUL: {
      return {
        ...state,
        type: ReserveActions.TX_SUCCESSFUL
      }
    }
    case ReserveActions.VERTHEIGHT_DETERMINDED: {
      return {
        ...state,
        navBarVertHeight: action.navBarVertHeight,
      }
    }
    default: {
      return state;
    }
  }
}

export default reserveReducer;
